
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !name) {
      setSubmitMessage('Por favor, preencha todos os campos.');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('name', name);

      const response = await fetch('https://readdy.ai/api/form/d3ifk5nuqofrij837nvg', {
        method: 'POST',
        body: new URLSearchParams(formData as any)
      });

      if (response.ok) {
        setSubmitMessage('Obrigado! Você foi inscrito em nossa newsletter.');
        setEmail('');
        setName('');
      } else {
        setSubmitMessage('Erro ao enviar. Tente novamente.');
      }
    } catch (error) {
      setSubmitMessage('Erro ao enviar. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-red-600 to-red-700 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <i className="ri-mail-line text-6xl text-yellow-300 mb-6 block"></i>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Fique por Dentro das Novidades
          </h2>
          <p className="text-xl text-red-100 max-w-2xl mx-auto">
            Receba em primeira mão informações sobre novos produtos, receitas exclusivas e promoções especiais
          </p>
        </div>

        <form onSubmit={handleSubmit} className="max-w-2xl mx-auto" data-readdy-form id="newsletter">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <input
              type="text"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Seu nome"
              className="px-6 py-4 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-red-300 text-lg"
              required
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu e-mail"
              className="px-6 py-4 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-red-300 text-lg"
              required
            />
          </div>
          
          <Button 
            type="submit" 
            size="lg" 
            className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold w-full md:w-auto"
            loading={isSubmitting}
          >
            <i className="ri-send-plane-line mr-2"></i>
            Inscrever-se na Newsletter
          </Button>
          
          {submitMessage && (
            <p className={`mt-4 text-lg ${submitMessage.includes('Obrigado') ? 'text-green-300' : 'text-red-300'}`}>
              {submitMessage}
            </p>
          )}
        </form>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex items-center justify-center md:justify-start">
            <i className="ri-notification-line text-2xl text-yellow-300 mr-3"></i>
            <span className="text-red-100">Novos Produtos</span>
          </div>
          <div className="flex items-center justify-center">
            <i className="ri-book-open-line text-2xl text-yellow-300 mr-3"></i>
            <span className="text-red-100">Receitas Exclusivas</span>
          </div>
          <div className="flex items-center justify-center md:justify-end">
            <i className="ri-price-tag-line text-2xl text-yellow-300 mr-3"></i>
            <span className="text-red-100">Promoções Especiais</span>
          </div>
        </div>
      </div>
    </section>
  );
}
